import React, { FC } from "react";

import Logo from "@/components/common/Logo";
import { HeaderDataItem } from "@/data/navigation/header.data";
import { PromoData } from "@/types/promoData";
import { cn } from "@/utils/general";
import { ThemeTypes } from "@/utils/theming";

import HeaderIcons from "./HeaderIcons";
import styles from "./NavFlex.module.scss";
import Navigation from "./Navigation";

interface MobileNavFlexProps {
  isAccountPage: boolean;
  isPdp: boolean;
  isQuizLp: boolean;
  navIsOpen: boolean;
  showCart: boolean;
  theme: ThemeTypes;
  toggleMobileNav: () => void;
  data: HeaderDataItem[];
  handleNavLogoExitClick: () => void;
  isIconVisibleOnRightSideOnly: boolean;
  location?: string;
  promoCf?: PromoData;
}

const MobileNavFlex: FC<MobileNavFlexProps> = (props) => {
  const {
    navIsOpen,
    isPdp,
    isAccountPage,
    isQuizLp,
    theme,
    toggleMobileNav,
    data,
    handleNavLogoExitClick,
    showCart,
    isIconVisibleOnRightSideOnly,
    promoCf,
  } = props;

  const isMen = theme === "men";

  return (
    <div className={cn("flex flex-nowrap items-center md:shadow-none", styles["mobile-nav-wrap"])}>
      <div
        className={cn(
          "toggler-wrap mobile-nav-flex",
          "w-[70px]",
          isAccountPage ? "h-[56px]" : "h-auto"
        )}
      >
        <HeaderIcons
          navIsOpen={navIsOpen}
          showCart={false}
          isProductPage={isPdp}
          isAccountPage={isAccountPage}
          isQuizLp={isQuizLp}
          theme={theme}
          toggleMobileNav={toggleMobileNav}
        />
      </div>
      <div
        className={cn(
          `left-wrap w-[calc(30%-70px)] `,
          isMen ? "lg:w-[calc(50%-91px)]" : "lg:w-[calc(50%-78px)]"
        )}
      >
        <Navigation data={data} promoCf={promoCf} />
      </div>
      <div className={cn("center-wrap w-[40%]", isMen ? "lg:w-[182px]" : "lg:w-[156px]")}>
        <Logo
          handleNavLogoExitClick={handleNavLogoExitClick}
          isAccountPage={isAccountPage}
          theme={theme}
        />
      </div>
      <div
        className={cn(
          "right-wrap w-[30%]  lg:pr-6",
          isMen ? "lg:w-[calc(50%-91px)]" : "lg:w-[calc(50%-78px)]"
        )}
      >
        <div className="flex flex-wrap items-center justify-end">
          <HeaderIcons
            navIsOpen={navIsOpen}
            showCart={showCart}
            theme={theme}
            showBurger={false}
            isProductPage={isPdp}
            isAccountPage={isAccountPage}
            isSimple={false}
            isQuizLp={isQuizLp}
            toggleMobileNav={toggleMobileNav}
            isIconVisibleOnRightSideOnly={isIconVisibleOnRightSideOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileNavFlex;
